import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from './CheckoutButton';
import { checkoutUrl, productImage } from '../data/content';
export function FinalCTA() {
  return <section className="bg-brand-navy px-4 py-5 text-center text-white sm:px-6" aria-labelledby="final-heading" data-id="element-54" data-mp="c7agudte4mkr">
      <h2 id="final-heading" className="mb-1 font-heading text-xl uppercase leading-tight sm:text-3xl" data-id="element-55" data-mp="844a752d8tdr">
        Une dernière opportunité
      </h2>
      <p className="mx-auto mb-2 max-w-xl text-[12px] font-medium leading-snug text-white/85 sm:text-sm" data-id="element-56" data-mp="m2lt8phbthpc">
        Chaque entraînement est une occasion d&apos;aider vos joueurs à progresser, à développer leur
        jeu et à atteindre un meilleur niveau. Ne perdez plus des heures à préparer chaque séance.
        Avec PADEL COACH READY™, vous disposez d&apos;un système complet pour organiser vos
        entraînements, construire des progressions efficaces et accompagner vos joueurs avec
        davantage de méthode. Offrez-vous enfin l&apos;outil professionnel que vous auriez aimé avoir
        dès le début de votre carrière.
      </p>
      <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-57" data-mp="2h2y7zbopcftx">
        <img src={productImage} alt="PADEL COACH READY™ — 6 modules et 5 bonus premium" className="mx-auto mb-2 w-full max-w-[220px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-58" data-mp="2r2go1h1hrhgp" />
      </a>
      <p className="font-heading text-lg uppercase leading-tight sm:text-2xl" data-id="element-59" data-mp="34tltx0vgd5zh">PADEL COACH READY™</p>
      <p className="mb-1 text-[11px] font-bold uppercase text-brand-green sm:text-xs" data-id="element-60" data-mp="39s5eoxyb8bq9">
        Le Système Complet de Planification 6-en-1 + 5 Bonus Premium
      </p>
      <p className="text-[12px] font-semibold text-white/70" data-id="element-61" data-mp="3epf268252dbg">
        Prix habituel : <span className="line-through" data-id="element-62" data-mp="3itmqi44opr95">97 €</span>
      </p>
      <p className="mb-2 font-heading text-2xl uppercase leading-none sm:text-3xl" data-id="element-63" data-mp="1jntsxxt8i5zx">
        Aujourd&apos;hui seulement : <span className="text-brand-green" data-id="element-64" data-mp="1eq1qwayvl3i0">27 €</span>
      </p>
      <div className="mx-auto max-w-md" data-id="element-65" data-mp="1sgn87v8ol5ds">
        <CheckoutButton data-id="element-66" data-mp="1shovcy2z1ibv">🚀 OUI ! JE VEUX PADEL COACH READY™</CheckoutButton>
      </div>
      <p className="mt-1.5 text-[11px] font-bold sm:text-xs" data-id="element-67" data-mp="1npopkp07zv7d">
        Accès immédiat • Livraison instantanée par e-mail
      </p>
      <div className="mt-1 flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold sm:flex-row sm:gap-4 sm:text-xs" data-id="element-68" data-mp="22d9u8ncqu2he">
        <span data-id="element-69" data-mp="2bfj2t7ogbls5">⭐ 4,9/5 — Avis vérifiés de coachs de padel</span>
        <span className="flex items-center gap-1" data-id="element-70" data-mp="2bezl9s2pqzen">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-71" data-mp="27e7bmxpxishu" />
          Garantie 7 jours — Zéro risque
        </span>
      </div>
    </section>;
}